import { render } from "./AboutOurWorkComponent.vue?vue&type=template&id=8b841ae0"
import script from "./AboutOurWorkComponent.vue?vue&type=script&lang=js"
export * from "./AboutOurWorkComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__